'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dotProp = require('dot-prop');

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _forEachDeep = require('./utils/forEachDeep');

var _forEachDeep2 = _interopRequireDefault(_forEachDeep);

var _JSON = require('./utils/JSON');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Transport = function (_EventEmitter) {
  _inherits(Transport, _EventEmitter);

  function Transport(id, expectedOrigin, connectedWindow) {
    _classCallCheck(this, Transport);

    var _this = _possibleConstructorReturn(this, (Transport.__proto__ || Object.getPrototypeOf(Transport)).call(this));

    _this.expectedOrigin = expectedOrigin;
    _this.connectedWindow = connectedWindow;
    _this.functions = {};
    _this.contexts = {};
    _this.unpackedFunctions = {};
    _this.i = 0;
    _this.onMessage = _this.onMessage.bind(_this);
    _this.subscribeEvents();
    _this.transportId = _this.prepareTransportId(id);
    _this.setMaxListeners(Infinity);
    return _this;
  }

  _createClass(Transport, [{
    key: 'destroy',
    value: function destroy() {
      this.unsubscribeEvents();
      this.functions = {};
      this.contexts = {};
      this.unpackedFunctions = {};
    }
  }, {
    key: 'generateId',
    value: function generateId() {
      return ++this.i;
    }
  }, {
    key: 'subscribeEvents',
    value: function subscribeEvents() {
      window.addEventListener('message', this.onMessage, true);
    }
  }, {
    key: 'unsubscribeEvents',
    value: function unsubscribeEvents() {
      window.removeEventListener('message', this.onMessage, true);
    }
  }, {
    key: 'prepareTransportId',
    value: function prepareTransportId(id) {
      return 'MAGIC_TRANSPORT:' + id;
    }
  }, {
    key: 'pack',
    value: function pack(object) {
      var _this2 = this;

      var functions = {};
      var checkedValues = [];
      (0, _forEachDeep2.default)(object, function (value, prop, subject, path, level) {
        if (checkedValues.indexOf(value) !== -1) return false;
        if (typeof value === 'function') {
          var context = level === 0 ? window : subject;
          var functionKey = '__' + _this2.transportId + ':functionId';
          var functionId = value[functionKey];
          if (!functionId) {
            functionId = _this2.generateId();
            Object.defineProperty(value, functionKey, {
              get: function get() {
                return functionId;
              }
            });
          }
          if (!_this2.functions[functionId]) _this2.functions[functionId] = function (ctx, args) {
            return new Promise(function (resolve, reject) {
              try {
                Promise.resolve(value.apply(ctx, args)).then(resolve, reject);
              } catch (e) {
                reject(e);
              }
            });
          };
          var contextKey = '__' + _this2.transportId + ':contextId';
          var contextId = context[contextKey];
          if (!contextId) {
            contextId = _this2.generateId();
            Object.defineProperty(context, contextKey, {
              get: function get() {
                return contextId;
              }
            });
          }
          if (!_this2.contexts[contextId]) _this2.contexts[contextId] = context;
          functions[path] = [functionId, contextId];
        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
          checkedValues.push(value);
        }
      });
      return functions;
    }
  }, {
    key: 'unpack',
    value: function unpack(obj, functions) {
      for (var key in functions) {
        if (functions.hasOwnProperty(key)) (0, _dotProp.set)(obj, key, this.unpackFunction(functions[key]));
      }
    }
  }, {
    key: 'unpackFunction',
    value: function unpackFunction(value) {
      var _this3 = this;

      var _value = _slicedToArray(value, 2),
          functionId = _value[0],
          contextId = _value[1];

      var key = functionId + '|' + contextId;
      if (!this.unpackedFunctions[key]) this.unpackedFunctions[key] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _this3.sendMessage({
          args: args,
          functionToInvoke: value,
          type: 'invoke',
          waitResponse: true
        }).then(function (_ref) {
          var result = _ref.response.result;
          return result;
        });
      };
      return this.unpackedFunctions[key];
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage(_ref2) {
      var _connectedWindow;

      var type = _ref2.type,
          _ref2$args = _ref2.args,
          args = _ref2$args === undefined ? [] : _ref2$args,
          _ref2$response = _ref2.response,
          response = _ref2$response === undefined ? {} : _ref2$response,
          responseToId = _ref2.responseToId,
          functionToInvoke = _ref2.functionToInvoke,
          waitResponse = _ref2.waitResponse;

      var id = this.generateId();
      var data = _defineProperty({}, this.transportId, {
        id: id,
        type: type,
        args: args,
        responseToId: responseToId,
        functionToInvoke: functionToInvoke,
        response: response,
        functions: _extends({}, this.pack(args), this.pack(response)),
        ts: Date.now()
      });
      var pmargs = [(0, _JSON.stringify)(data)];
      var origin = this.expectedOrigin && this.expectedOrigin !== '*' ? this.expectedOrigin : '*';
      if (origin) pmargs.push(origin);
      (_connectedWindow = this.connectedWindow).postMessage.apply(_connectedWindow, pmargs);
      if (waitResponse) return this.waitResponse(id);
    }
  }, {
    key: 'waitResponse',
    value: function waitResponse(id) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.once('response:' + id, function (data) {
          var error = data.response.error;

          if (error) reject(error);else resolve(data);
        });
      });
    }
  }, {
    key: 'checkOrigin',
    value: function checkOrigin(origin) {
      return !this.expectedOrigin || this.expectedOrigin === '*' || origin === this.expectedOrigin;
    }
  }, {
    key: 'onMessage',
    value: function onMessage(event) {
      var data = event.data;

      if (typeof data !== 'string' || !this.checkOrigin(event.origin)) return;
      try {
        data = (0, _JSON.parse)(data);
      } catch (error) {
        data = {};
      }
      if (!data[this.transportId]) return;
      if (!this.connectedOrigin) this.connectedOrigin = event.origin;
      this.handleMessage(data[this.transportId], event.source);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage(data, source) {
      var type = data.type,
          args = data.args,
          functions = data.functions,
          response = data.response;

      switch (type) {
        case 'invoke':
          this.unpack(args, functions);
          this.handleInvoke(data);
          break;
        case 'response':
          this.unpack(response, functions);
          this.handleResponse(data);
          break;
        case 'initialize':
          this.unpack(args, functions);
          this.handleInitialize && this.handleInitialize(data, source);
          break;
      }
    }
  }, {
    key: 'handleResponse',
    value: function handleResponse(data) {
      var responseToId = data.responseToId;

      this.emit('response:' + responseToId, data);
    }
  }, {
    key: 'handleInvoke',
    value: function handleInvoke(_ref3) {
      var _this5 = this;

      var functionToInvoke = _ref3.functionToInvoke,
          args = _ref3.args,
          id = _ref3.id;

      var _functionToInvoke = _slicedToArray(functionToInvoke, 2),
          functionId = _functionToInvoke[0],
          contextId = _functionToInvoke[1];

      var func = this.functions[functionId];
      var context = this.contexts[contextId];
      new Promise(function (resolve, reject) {
        try {
          Promise.resolve(func(context, args)).then(resolve, function (e) {
            reject(e);
            throw e;
          });
        } catch (e) {
          reject(e);
          throw e;
        }
      }).then(function (result) {
        return _this5.sendMessage({ type: 'response', response: { result: result }, responseToId: id });
      }, function (error) {
        return _this5.sendMessage({ type: 'response', response: { error: error }, responseToId: id });
      });
    }
  }]);

  return Transport;
}(_events2.default);

exports.default = Transport;